import { uploadMultiPart } from "smartassess-api-lib";
import {
  ab2b64,
  generateEncryptionKeyApi,
  importAesKey,
} from "../../service/EncryptionApi/EncryptionApi";

export const ImageUploader = async (e: any, path?: string) => {
  const fileData = [];
  for (let i = 0; i < e.target.files.length; i += 1) {
    fileData.push(e.target.files[i]);
  }
  const jsonData = {
    file: fileData,
    path: path,
    startUploadEndPoint: "s3Upload/startUpload",
    getPresignedEndPoint: "s3Upload/generatePresigned",
    completeUploadEndPoint: "s3Upload/completeUpload",
  };
  const imageData = await uploadMultiPart(jsonData);
  e.target.value = "";
  return imageData?.data?.data;
};
// This function work for multifile upload.
export const MultiFileUploader = async (e: any, path?: string) => {
  const fileData = [e];
  const jsonData = {
    file: fileData,
    path: path,
    startUploadEndPoint: "s3Upload/startUpload",
    getPresignedEndPoint: "s3Upload/generatePresigned",
    completeUploadEndPoint: "s3Upload/completeUpload",
  };
  const imageData = await uploadMultiPart(jsonData);
  return imageData?.data?.data;
};

// function to upload encrypted file
export const uploadEncryptedFile = async (e: any, path?: string) => {
  const fileData: Blob[] = [];
  let meta = {};
  for (let i = 0; i < e.target.files.length; i += 1) {
    const file = e.target.files[i];
    const generateEncryptionRespons = await generateEncryptionKeyApi();
    const iv = crypto.getRandomValues(
      new Uint8Array(generateEncryptionRespons.ivLength || 12),
    );
    const ivB64 = ab2b64(iv.buffer);
    meta = {
      encryptedkey: generateEncryptionRespons.encryptedKeyBase64,
      iv: ivB64,
      algo: generateEncryptionRespons.algo,
    };
    const key = await importAesKey(
      generateEncryptionRespons.plaintextKeyBase64,
    );
    const buf = await file.arrayBuffer(); // convert file to array buffer
    const ciphertext = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      key,
      buf,
    );

    // Create encrypted blob (same as videoUploader)
    const encryptedBlob = new Blob([ciphertext], {
      type: file.type,
    });
    const encryptedFile = new File([encryptedBlob], file.name, {
      type: file.type,
    });
    fileData.push(encryptedFile);
  }

  const jsonData = {
    file: fileData,
    path,
    startUploadEndPoint: "s3Upload/startUpload",
    getPresignedEndPoint: "s3Upload/generatePresigned",
    completeUploadEndPoint: "s3Upload/completeUpload",
    meta,
  };
  const imageData = await uploadMultiPart(jsonData);
  e.target.value = "";
  return imageData?.data?.data;
};

// function to upload mutiple encrypted files
export const uploadMutipleEncryptedFiles = async (
  file: File,
  path?: string,
) => {
  // 🔑 Generate encryption keys for this file
  const generateEncryptionResponse = await generateEncryptionKeyApi();
  const iv = crypto.getRandomValues(
    new Uint8Array(generateEncryptionResponse.ivLength || 12),
  );
  const ivB64 = ab2b64(iv.buffer);

  const meta = {
    encryptedKey: generateEncryptionResponse.encryptedKeyBase64,
    iv: ivB64,
    algo: generateEncryptionResponse.algo,
  };

  // 🔑 Import AES key
  const key = await importAesKey(generateEncryptionResponse.plaintextKeyBase64);

  // 📂 Convert file → ArrayBuffer → Encrypt
  const buf = await file.arrayBuffer();
  const ciphertext = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    buf,
  );

  // 🔒 Encrypted Blob
  const encryptedBlob = new Blob([ciphertext], { type: file.type });
  const encryptedFile = new File([encryptedBlob], file.name, {
    type: file.type,
  });

  // 📤 Prepare upload data
  const jsonData = {
    file: [encryptedFile],
    path,
    startUploadEndPoint: "s3Upload/startUpload",
    getPresignedEndPoint: "s3Upload/generatePresigned",
    completeUploadEndPoint: "s3Upload/completeUpload",
    meta,
  };
  const imageData = await uploadMultiPart(jsonData);
  return imageData?.data?.data;
};
